module.exports = __webpack_public_path__ + "static/media/video-kamera.c88d45f9.png";